import { gql } from "@apollo/client"

export default gql`
  query RestrictedEmailDomain {
    restricted_email_domain {
      email_domain
      id
    }
  }
`
